import { Component, OnDestroy, SimpleChanges, OnChanges, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Output, Pipe, PipeTransform, EventEmitter, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location, DatePipe } from '@angular/common'
import { Subject, Observable } from 'rxjs';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate, animation } from '@angular/animations';
import { CustomerService } from '../../services/customer.service';
import { OrdersService } from '../../services/orders.service';
import { InventoryService } from '../../services/inventory.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { UsersService } from '../../services/users.service';
import { PurchasingService } from '../../services/purchasing.service';
import { CreditService } from '../../services/credit.service';
import { OmsService } from '../../services/oms.service';
import { Tpl3plService } from '../../services/tpl3pl.service';


@Component({
	selector: 'app-shared-credit-entry',
	templateUrl: './shared-credit-entry.component.html',
	styleUrls: ['./shared-credit-entry.component.scss'],
	encapsulation: ViewEncapsulation.Emulated,
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('inactive => active', animate('300ms ease-in')),
			transition('active => inactive', animate('300ms ease-out')),
		]),
		trigger('cinfo', [
			transition(':enter', [
				animate('50ms', style({ opacity: 1, height: 100 })),
			]),
			transition(':leave', [
				animate('100ms', style({ opacity: 1, height: 0 }))
			]),
		]),
		trigger('itemSearch', [
			transition(':enter', animation([style({ transform: 'translate(-800px,0)', }),
				animate('0.2s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(1200px,0)', })
				),
			])),
		]),
		trigger('addFilters', [
			transition(':enter', animation([style({ transform: 'translate(200px,0)', }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(-200px,0)', })
				),
			])),
		]),
		trigger('navIn', [
			transition(':enter', animation([style({ transform: 'translate(200px,0)', }),
				animate('0.10s cubic-bezier(0.59, 0.32, 0.38, 0.33)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.0s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(-200px,0)', })
				),
			])),
		]),
	],
})

export class SharedCreditEntryComponent implements OnInit {

	@Input() customer: any = false;
	@Input() original_order: any = false;
	@Input() flip = 'inactive';
	@Input() type = '11';
	@Input() invoicing: any = false;
	@Input() cart_items: any = [];
	@Output() reloadCustomer = new EventEmitter < any > ();
	totalsupdating: any = false;
	totalsshowspinner : any = false;
	CHAT_ROOM = 'OrderBoard';
	config: any = [];
	user: any = [];
	proceed: any = true;
	total_cart_qty = 0;
	cart_totals: any = [];

	overcredit: any = false;
	allowed_credit: any = true;
	overcredit_override: any = true;
	checkCreditLimits = 0;
	editing_order: any = false;
	order_details: any = false;
	//orderResults: any = false;

	customer_form: any = false;

	po_vendors: any = [];
	order: any = false;
	created_pos: any = false;
	extra_pos: any = false;
	order_lines: any = false;
	loading_remote = false;
	orderno: any = false;
	remoteqtys: any = [];
	sending = false;
	purchase_item: any = false;
	purchordercreated_details: any = false;
	purchasedetails: any = false;
	purchordercreated: any = false;

	baselink = '';
	pickingInvoiceLink = '';

	orderDetails: any = false;
	orderResults: any = false;
	invoiceResults: any = false;

	anydata = {
		'success': true,
		'orderno': '754076',
		'transno': null,
		'order': '754076',
		'id': null
	};

	freight_charge: any = 0.00;
	fetchingTotals: any = false;
	fetchingCart: any = false;
	purchase_items: any = [];
	creditLink = '';
	baseUrl = '';
	custNotes: any = [];

	tpl3plPgsEnabled = false;
	pgsSending = false;
	pgsResult: any = null;
	constructor(private creditService: CreditService, private purchasingService: PurchasingService, private inventoryService: InventoryService, private route: ActivatedRoute, private customerService: CustomerService, private orderService: OrdersService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, public omsService: OmsService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public usersService: UsersService, private tpl3plService: Tpl3plService) {

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
		});

		this.baseUrl = this.config.apiServer.baseUrl;
		this.baselink = this.config.apiServer.baseUrl + this.config.apiServer.creditPickingLink;
		this.creditLink = this.config.apiServer.creditLink
		this.pickingInvoiceLink = this.config.apiServer.baseUrl + this.config.apiServer.creditLink;

		this.globalSearchService.user.subscribe((results: any) => {
			if (results) {
				this.user = results.user;
			}
		});
		this.globalsService.getCheckCreditLimits().subscribe(v => this.checkCreditLimits = v);
	}


	invoiceOrder(orderno: any) {
		this.invoicing = orderno;
		this.orderResults = false;
		//this.router.navigate(['/orders/invoice/' + this.orderResults.orderno]);
		this.router.navigate(['/receivables/dispatch/' + orderno]);
	}

	updateCustomer(event: any) {
		this.customer_form = event
		if (this.editing_order) {
			const oldBranch = this.order_details.header.branchcode;
			const newBranch = this.customer_form.get('branchcode').value;
			oldBranch != newBranch ? this.order_details.header.branchcode = newBranch : '';
		}
		this.reloadCustomer.emit(this.customer_form);
	}

	updateShipping(value: any) {
		this.freight_charge = value
		this.updateTotals();
	}

	addItems(items: any) {

		this.creditService.addMultipleToOrder(items, this.customer.debtorno, this.customer.branchcode).subscribe((results: any) => {

			if (results.success) {
				this.cart_items = results.cart;
				//this.updateTotals();

				if (results.warn) {
					this.globalSearchService.showNotification(results.message, 'warning', 'bottom', 'left');
				}


				items.forEach((item, index) => {
					//reset qtys and show notification
					if (parseFloat(item.quantity) != 0) {
						const color = (item.isnegative) ? 'warn' : 'success';
						this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Added', color, 'bottom', 'left');
					}
				});



			} else {
				this.globalSearchService.showNotification(results.message, 'danger', 'bottom', 'left');
			}

			this.updateTotals();
		});


	}

	removeFromOrder(cart_id) {
		this.creditService.removeFromOrder(cart_id, this.customer.debtorno, this.customer.branchcode).subscribe((results: any) => {
			this.cart_items = results;
			this.globalSearchService.showNotification('Item Removed', 'danger', 'bottom', 'left');
			this.updateTotals();
			this.sendCartUpdate();
		});
	}

	updatePrice(event: any, item: any) {
		const index = this.cart_items.indexOf(item);
		this.cart_items[index].price = event.target.value;
		this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Updated', 'warning', 'bottom', 'left');
		this.updateCartItem(this.cart_items[index]);
	}

	updateQuantity(event: any, item: any) {
		const index = this.cart_items.indexOf(item);
		this.cart_items[index].quantity = event.target.value;
		this.globalSearchService.showNotification(item.description + ' x ' + item.quantity + ' Updated', 'warning', 'bottom', 'left');
		this.updateCartItem(this.cart_items[index]);
	}

	updateDiscount(event: any, item: any) {
		const index = this.cart_items.indexOf(item);
		this.cart_items[index].discount = event.target.value;
		this.updateCartItem(this.cart_items[index]);
	}

	updateNote(event: any, item: any) {
		const index = this.cart_items.indexOf(item);
		this.cart_items[index].notes = event.target.value;
		this.updateCartItem(this.cart_items[index]);
	}

	getDiscounPrice(item: any) {
		const discountprice = this.financial((item.price * (item.discount / 100)));
		let total = this.financial(item.price - discountprice);
		if (total < 0) {
			total = 0;
		}
		return total;
	}

	getDiscountTotal(item: any) {
		let total = item.quantity * (item.price - (item.price * (item.discount / 100)));
		if (total < 0) {
			total = 0;
		}
		return total;
	}

	updateChildren() {
		this.cart_items.forEach((item: any) => {
			if (item.parent_id) {
				const parent = this.cart_items.filter(i => i.cart_id == item.parent_id)[0]

				//will not work for pers
				item.quantity = parent.quantity;
			}
		})
	}


	updateCartItem(item: any) {

		const data = {
			customer: this.customer.debtorno,
			branch: this.customer.branchcode,
			cartid: item.cart_id,
			cart_id: item.cart_id,
			price: item.price,
			option: item.options,
			quantity: item.quantity,
			discount: item.discount,
			notes: item.notes,
			stockid: item.stockid,
			editing_order: this.editing_order,
			order_details: this.order_details,
		};

		this.creditService.updateOrder(data).subscribe((results: any) => {
			this.updateTotals();
			this.updateChildren();
		});

	}


	updateTotals() {
		const orig = this.original_order?.header?.orderno ?? '';
		this.totalsshowspinner = true;
		if (this.totalsupdating) {
			this.totalsupdating.unsubscribe();
		}

		this.totalsupdating = this.creditService.getTotals(this.customer.debtorno, this.customer.branchcode, this.freight_charge, orig)
			.subscribe((results: any) => {
				this.cart_totals = results;
				this.total_cart_qty = this.cart_items.reduce((accumulator: number, item: any) =>
					accumulator + parseFloat((item.quantity || '0').toString().trim()), 0);

				// Ensure total_cart_qty is a valid number before setting flip
				if (!isNaN(this.total_cart_qty)) {
					this.flip = this.total_cart_qty ? this.flip : 'inactive';
				}

				this.totalsshowspinner = false;

				this.checkCreditLimit();
			});
	}


	getTotal() {

		const total = this.cart_totals.filter(t => {
			return t.code == 'total';
		})[0]

		let value = 0.00;
		if (total) {
			value = parseFloat(parseFloat(total.text).toFixed(2))
		}

		return value;
	}

	checkCreditLimit() {
		if (this.checkCreditLimits === 0 || !this.customer) { return; }
		if (!this.allowed_credit) {
			this.proceed = true;
		}
		this.overcredit = false;
		if (!Array.isArray(this.cart_totals)) { return; }
		const subtotal = this.cart_totals.filter(t => t.code === 'sub_total')[0];
		if (subtotal && this.customer.credit_avail != null && parseFloat(subtotal.text) > this.customer.credit_avail) {
			this.overcredit = true;
		}
	}


	stopProp(event: any): void {
		event.stopPropagation();
	}

	sendCartUpdate() {

		if (this.user) {

			//let data = [{ customer: this.customer.debtorno, user: this.user }]

			//this.omsService.sendCartUpdate({ data, roomName: 'CartRoom' }, cb => {});
		}
	}

	toggleFlip() {

		switch (this.flip) {
		case 'inactive':
			this.flip = 'active';
			break;
		default:
			this.flip = 'inactive';
			break;
		}
	}

	reloadOrder(event: any) {

		//todo - reload header into form
		this.creditService.getCart(this.customer.debtorno, this.customer.branchcode).subscribe(async (items: any) => {
			//this.selectedindex = 0;
			this.editing_order = true;
			this.order_details = event;
			this.cart_items = items;
			if (items.length) {

				if (!items[0].override || items[0].override == '') {
					//order was not flagged - do not stop it
					this.proceed = true;
					this.allowed_credit = true;
					this.overcredit_override = items[0].override
				}
			}

			this.updateTotals();
		});
	}

	ngOnInit(): void {
		// this.updateCart();
		this.getCustomerNotes();

		if (this.config?.env?.client === 'km') {
			this.tpl3plService.getConfig().subscribe({
				next: (cfg: any) => {
					this.tpl3plPgsEnabled = !!(cfg?.enabled && cfg?.integration_type === 'PGS');
				},
				error: () => { this.tpl3plPgsEnabled = false; }
			});
		}
	}

	sendToPgs(forceResend = false): void {
		if (!this.tpl3plPgsEnabled || this.pgsSending || !this.orderResults?.orderno) { return; }
		this.pgsSending = true;
		this.pgsResult = null;
		this.creditService.sendRmaToPgs(String(this.orderResults.orderno), forceResend).subscribe({
			next: (result: any) => {
				this.pgsSending = false;
				this.pgsResult = result;
				this.globalSearchService.showNotification(
					result.success ? 'RMA sent to 3PL' : ('3PL send failed: ' + (result.message || '')),
					result.success ? 'success' : 'warning',
					'bottom', 'right'
				);
			},
			error: (err: any) => {
				this.pgsSending = false;
				this.pgsResult = { success: false, message: err?.error?.message || 'Request failed' };
				this.globalSearchService.showNotification('3PL send failed', 'warning', 'bottom', 'right');
			}
		});
	}

	getCustomerNotes(){
		if(this.customer?.debtorno) {
			const data = {
				debtorno : this.customer.debtorno,
				branch: this.customer.branchcode
			}
			this.customerService.getCustomerNotes(data).subscribe(notes => {
				this.custNotes = notes.filter(note => note.note_code.toUpperCase() === 'ORDER');
			});
		}

	}

	ngOnChanges(changes: any) {
		// If the parent has flagged an existing RMA being edited, set editing_order
		// immediately — don't wait for the async updateCart() to detect it via cart items.
		if (changes.customer && this.customer?.editingorder && !this.editing_order) {
			this.editing_order = true;
			if (!this.order_details || !this.order_details.header) {
				this.order_details = { header: this.customer.editingorder };
			}
		}
		this.updateCart();
	}

	saveQuote() {
		this.orderService.saveQuote(this.customer, this.cart_items, this.cart_totals, this.user, this.customer_form.value).subscribe((result: any) => {
			this.globalSearchService.showNotification('Quote ' + result.orderno + ' Saved', 'success', 'bottom', 'left');
			this.reloadCustomer.emit(true)
			this.clearCart();
			this.updateCart();
		});
	}

	emitCustomerUpdate(event: any) {
		this.invoicing = false;
		this.reloadCustomer.emit(event);
	}

	clearCart() {
		this.creditService.clearOrder(this.customer.debtorno, this.customer.branchcode).subscribe((results: any) => {
			this.flip = 'inactive';
			this.updateCart();
		});
	}

	placeOrder() {

		this.checkCreditLimit();
		this.globalSearchService.getFormValidationErrors(this.customer_form);
		this.customer_form.markAllAsTouched();

		if (this.checkCreditLimits !== 0 && this.overcredit) {
			this.globalSearchService.showNotification(
				'Over credit limit — order will be placed on credit hold.',
				'warning',
				'bottom',
				'right'
			);
		}

		if (this.customer_form.valid && this.proceed) {
			if(this.config.env.package === 'tires'){
				const ep = this.usersService.usePrintConnect();
				this.user.usePrintConnect = ep;
			}


			if (!this.editing_order) {
				const customerPayload = { ...this.customer_form.value, overcredit_override: this.overcredit_override };
				this.creditService.createOrder(customerPayload, this.cart_items, this.cart_totals, this.user).subscribe((results: any) => {
					this.globalSearchService.orderResults.next(results);
					this.orderResults = results;
					this.pgsResult = null;
					if (results?.success && results.credit_hold) {
						this.globalSearchService.showNotification(
							results.credit_hold_message || 'Order placed on credit hold (over limit).',
							'warning',
							'bottom',
							'right'
						);
					}
					this.flip = 'inactive';
					this.orderDetails = results;
					this.reloadCustomer.emit(results);
					this.editing_order = false;
					//let data = { message: 'neworder' }
					//this.omsService.sendCardUpdate({data, roomName: this.CHAT_ROOM}, cb => {
					//});
					//this.omsService.sendOpenOrderUpdate({data, roomName: this.CHAT_ROOM}, cb => {
					//});

					if(this.user.usePrintConnect){
						this.sendPrint(results['base64']);
					}

					this.creditService.clearOrder(this.customer.debtorno, this.customer.branchcode).subscribe((r: any) => {
						this.cart_items = [];
						this.total_cart_qty = 0;
						const data = {};
						this.omsService.sendOrderPickUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
						//this.router.navigate(['/orders/invoice/' + this.orderResults.orderno]);
					});


				});
			} else {
				//read printconnect from local storage
				if(this.config.env.package === 'tires'){
					const ep = this.usersService.usePrintConnect();
					this.user.usePrintConnect = ep;
				}

				this.creditService.updateSalesOrder(this.customer_form.value, this.cart_items, this.cart_totals, this.order_details, this.user).subscribe((results: any) => {
					this.flip = 'inactive';
					this.globalSearchService.orderResults.next(results);
					this.orderResults = results;
					if (results?.success && results.credit_hold) {
						this.globalSearchService.showNotification(
							results.credit_hold_message || 'Order updated — on credit hold (over limit).',
							'warning',
							'bottom',
							'right'
						);
					}
					const data = {};
					this.omsService.sendOrderPickUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
					//this.router.navigate(['/orders/invoice/' + this.orderResults.orderno]);
					if(this.user.usePrintConnect){
						this.sendPrint(results['base64']);
					}
				});
			}
		}

		this.updateCart()
	}

	sendPrint(in_data: any = [] ){
		const type = 'CREDIT';
		const user = this.user.userid;
		const printers = this.usersService.getDevicesByType(user, type);
		if (printers && printers.length && in_data.length) {
			this.omsService.setNewOrder();
			const rma = in_data[0];
			const data = { pdf: rma, user: user, devices: printers }	
			this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
				this.omsService.setPrintedOrder();
			})
		}
	}

	showInvoiceResultandReset(event: any) {
		//this.invoiceResults = event;
		this.globalSearchService.showNotification('Credit #' + event.invoice.transno + ' Created', 'success', 'bottom', 'left');
		this.resetOrder();
	}

	resetOrder() {
		this.invoicing = false;
		this.orderResults = false;
		this.order_details = false;
		this.editing_order = false;
		this.original_order = false;
		this.clearCart();
		this.updateTotals();
	}

	updateCart() {
		this.creditService.getCart(this.customer.debtorno, this.customer.branchcode).subscribe((items: any) => {
			if (items.length) {
				this.flip = 'active';
			}
			const hasorderno = items.find((item: any) => item.orderno && item.orderno != 0)?.orderno ?? false;
			if (hasorderno && !(this.order_details && this.order_details.header)) {
				this.creditService.loadRma(hasorderno).subscribe((results: any) => {
					this.editing_order = true;
					this.order_details = results;
					this.cart_items = results.cart;
					if (!this.original_order && results.original_order && results.original_order.header) {
						this.original_order = results.original_order;
					}
					// New reference so credit-review's ngOnChanges re-seeds the form
					// (freightcost, shipvia, addresses) from the RMA being edited.
					this.customer = { ...this.customer, editingorder: results.header };
					const rmafreight = parseFloat(results.header.freightcost);
					if (!isNaN(rmafreight)) {
						this.updateShipping(rmafreight);
						this.updateTotals();
					}
				});
			} else {
				this.cart_items = items;
			}

			// Editing an existing RMA: its stored freight wins. A fresh credit loaded
			// from an invoice carries the source order's remaining freight. The beauty
			// zero-freight default must never wipe a loaded RMA's freight.
			const editfreight = (this.editing_order && this.order_details && this.order_details.header) ? parseFloat(this.order_details.header.freightcost) : NaN;
			const origfreight = (this.original_order && this.original_order['header']) ? parseFloat(this.original_order['header']['freightcost']) : NaN;
			if (!isNaN(editfreight)) {
				this.updateShipping(editfreight);
			} else if (!isNaN(origfreight) && origfreight > 0) {
				this.updateShipping(origfreight);
			} else if (this.config.env.package === 'beauty' && !this.editing_order) {
				this.updateShipping(0);
			}

			this.updateTotals();
		});
	}

	editOrder(orderno: any) {
		this.orderResults = false;
		this.creditService.loadRma(orderno).subscribe((results: any) => {
			this.editing_order = true;
			this.order_details = results;
			if (results.original_order && results.original_order.header) {
				this.original_order = results.original_order;
			}

			this.fetchingCart = this.creditService.getCart(results.header.debtorno, results.header.branchcode).subscribe(async (items: any) => {


				//this.selectedindex = 0;
				this.editing_order = true;
				this.order_details = results;
				this.cart_items = items;
				// New reference so credit-review's ngOnChanges re-seeds the form
				// (freightcost, shipvia, addresses) from the RMA being edited.
				this.customer = { ...this.customer, editingorder: results.header };

				const rmafreight = parseFloat(results.header.freightcost);
				if (!isNaN(rmafreight)) {
					this.updateShipping(rmafreight);
				}

				if (items.length) {

					if (!items[0].override || items[0].override == '') {
						//order was not flagged - do not stop it
						this.proceed = true;
						this.allowed_credit = true;
						this.overcredit_override = items[0].override
					}
				}

				this.updateTotals();
			});

			this.flip = 'active';

			//this.router.navigate(['/orders/entry/'+link]);
		})
	}

	// Use Math.round for standard rounding to the nearest cent
	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(2));
	}
	
	toNegative(value: any): number {
		return -Math.abs(parseFloat(value));
	}
}